var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"w-100 d-block d-md-none",attrs:{"href":"https://t.me/Valutix_manager","target":"_blank"}},[_c('picture',[_c('source',{attrs:{"media":"(min-width:500px)","srcset":"/static/img/go_telegram/vconcierge.jpg"}}),_c('img',{staticClass:"rounded overflow-hidden w-100",attrs:{"src":"/static/img/go_telegram/vconcierge_mob.jpg"}})])])
}]

export { render, staticRenderFns }